//@author: mandy
import { inject, Injectable } from "@angular/core";
import { DataAccess } from "../../../../dataaccess/data.access";
import { S25Util } from "../../../../util/s25-util";
import { Cache, CacheRepository } from "../../../../decorators/cache.decorator";
import { jSith } from "../../../../util/jquery-replacement";
import { LoginStore } from "../../../../stores/login.store";

@Injectable({ providedIn: "root" })
export class DashService {
    private readonly loginStore = inject(LoginStore);

    @Cache({ targetName: "DashService" })
    async get() {
        const data = await DataAccess.get(DataAccess.injectCaller("/home/dash/dash.json", "DashService.get"));
        const dash = data.dash;
        dash.sections &&
            dash.sections.map(function (section: any) {
                section.panels &&
                    (section.panels = section.panels.reduce(function (result: any, panel: any) {
                        const panelId = parseInt(panel.panelId);
                        const typeId = parseInt(panel.typeId);
                        // Exclude panelId=11 'Recently Viewed'
                        if (panelId === 11) {
                            return result;
                        }
                        return result.concat(panel);
                    }, []));
            });
        return dash;
    }

    refresh() {
        return this.get();
    }

    async reset() {
        if (!this.loginStore.loggedIn()) {
            return this.get();
        }
        const putResponse = await DataAccess.put(DataAccess.injectCaller("/home/dash/reset.json", "DashService.reset"));
        CacheRepository.invalidateFunction(this.get);
        const dashFromResponse = putResponse?.dash;
        return dashFromResponse ?? this.get();
    }

    async putPanelsOrder(data: any) {
        if (!this.loginStore.loggedIn()) {
            return;
        }
        const filterModel = function (payload: any) {
            const sectionsArr: any = [];
            jSith.forEach(payload.sections, function (key: any, value: any) {
                const panelsArr: any = [];
                jSith.forEach(value.panels, function (panelkey: any, panelvalue: any) {
                    panelsArr.push({ panelId: panelvalue.panelId });
                });
                sectionsArr.push({ sectionId: value.sectionId, panels: panelsArr });
            });
            return { dash: { sections: sectionsArr } };
        };
        const jsonPayload = S25Util.toJson(filterModel(data));
        return DataAccess.put(
            DataAccess.injectCaller("/home/dash/panels-order.json", "DashService.putPanelsOrder"),
            jsonPayload,
        );
    }
}
